export default __webpack_public_path__ + "static/media/blue-caret-down.ee9b24f3.svg";